import { Layout as RaLayout } from 'react-admin';
import CustomAppBar from './CustomAppBar';
import CustomSidebar from './CustomSideBar';

export const Layout = (props) => (
    <RaLayout
        {...props}
        appBar={CustomAppBar}
        sidebar={CustomSidebar}
        sx={{
            '& .RaLayout-content': {
                // This is the main content wrapper
                padding: 0,
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                position: 'relative',
                marginTop: 0, // Remove any top margin
            },
            '& .RaLayout-appFrame': {
                // This is the app frame that contains everything
                overflow: 'hidden',
                width: '100%',
                maxWidth: '100%',
                marginTop: 0, // Remove any top margin
            },
            '& .RaLayout-root': {
                marginTop: 0, // Remove any top margin from root
            },
            // Hide any default AppBar that might still be rendered
            '& .MuiAppBar-root:not(:first-of-type)': {
                display: 'none',
            }
        }}
    />
);